import client from './client'

export default {
  resultsArchetypes (params) {
    return client.withAuth().get('womapi/api/output/archetypes', params)
  },
  resultsArchetypesExcel (params) {
    return client.withAuth().get('womapi/api/output/archetypes', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsBrands (params) {
    return client.withAuth().get('womapi/api/output/brands', params)
  },
  resultsBrandsExcel (params) {
    return client.withAuth().get('womapi/api/output/brands', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsBrandsSort (params) {
    return client.withAuth().get('womapi/api/output/brands', params)
  },
  resultsSustainability (params) {
    return client.withAuth().get('womapi/api/output/sustainability', params)
  },
  resultsSustainabilityExcel (params) {
    return client.withAuth().get('womapi/api/output/sustainability', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsSustainabilitySort (params) {
    return client.withAuth().get('womapi/api/output/sustainability', params)
  },
  resultsLifestyle (params) {
    return client.withAuth().get('womapi/api/output/lifestyle', params)
  },
  resultsLifestyleExcel (params) {
    return client.withAuth().get('womapi/api/output/lifestyle', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsLifestyleSort (params) {
    return client.withAuth().get('womapi/api/output/lifestyle', params)
  },
  resultsMedia (params) {
    return client.withAuth().get('womapi/api/output/media', params)
  },
  resultsMediaExcel (params) {
    return client.withAuth().get('womapi/api/output/media', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsMediaSort (params) {
    return client.withAuth().get('womapi/api/output/media', params)
  },
  resultsPersuasion (params) {
    return client.withAuth().get('womapi/api/output/persuasiontactics', params)
  },
  resultsPersuasionExcel (params) {
    return client.withAuth().get('womapi/api/output/persuasiontactics', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsPersuasionSort (params) {
    return client.withAuth().get('womapi/api/output/persuasiontactics', params)
  },
  resultsPolitics (params) {
    return client.withAuth().get('womapi/api/output/politics', params)
  },
  resultsPoliticsExcel (params) {
    return client.withAuth().get('womapi/api/output/politics', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsPoliticsSort (params) {
    return client.withAuth().get('womapi/api/output/politics', params)
  },
  resultsDemographics (params) {
    return client.withAuth().get('womapi/api/output/sociodemographics', params)
  },
  resultsDemographicsExcel (params) {
    return client.withAuth().get('womapi/api/output/sociodemographics', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsDemographicsSort (params) {
    return client.withAuth().get('womapi/api/output/sociodemographics', params)
  },
  resultsUndercurrent (params) {
    return client.withAuth().get('womapi/api/output/trends', params)
  },
  resultsUndercurrentExcel (params) {
    return client.withAuth().get('womapi/api/output/trends', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsValuesCards (params) {
    return client.withAuth().get('womapi/api/output/valuescards', params)
  },
  resultsValuesCardsExcel (params) {
    return client.withAuth().get('womapi/api/output/valuescards', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsMentality (params) {
    return client.withAuth().get('womapi/api/output/valuessegments', params)
  },
  resultsMentalityExcel (params) {
    return client.withAuth().get('womapi/api/output/valuessegments', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsBurgerschapsstijlen(params) {
    return client.withAuth().get('womapi/api/output/burgerschapsstijlen', params)
  },
  resultsBurgerschapsstijlenExcel(params) {
    return client.withAuth().get('womapi/api/output/burgerschapsstijlen', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsFintality(params) {
    return client.withAuth().get('womapi/api/output/fintality', params)
  },
  resultsFintalityExcel(params) {
    return client.withAuth().get('womapi/api/output/fintality', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsShopperMentality(params) {
    return client.withAuth().get('womapi/api/output/shoppermentality', params)
  },
  resultsShopperMentalityExcel(params) {
    return client.withAuth().get('womapi/api/output/shoppermentality', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsVitality(params) {
    return client.withAuth().get('womapi/api/output/vitality', params)
  },
  resultsVitalityExcel(params) {
    return client.withAuth().get('womapi/api/output/vitality', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsZorgMentality(params) {
    return client.withAuth().get('womapi/api/output/zorgmentality', params)
  },
  resultsZorgMentalityExcel(params) {
    return client.withAuth().get('womapi/api/output/zorgmentality', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsVijfTintenGroener(params) {
    return client.withAuth().get('womapi/api/output/vijftintengroener', params)
  },
  resultsVijfTintenGroenerExcel(params) {
    return client.withAuth().get('womapi/api/output/vijftintengroener', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  },
  resultsVrijetijdsprofielen(params) {
    return client.withAuth().get('womapi/api/output/vrijetijdsprofielen', params)
  },
  resultsVrijetijdsprofielenExcel(params) {
    return client.withAuth().get('womapi/api/output/vrijetijdsprofielen', params, {}, { 'Accept': 'application/vnd.ms-excel' }, {})
  }
}
